var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPieChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.7657 63.0389C76.8087 67.5613 73.7751 71.5362 69.9294 74.6172C66.0837 77.6982 61.5427 79.7916 56.7023 80.715C51.8619 81.6383 46.8692 81.3636 42.1594 79.9146C37.4495 78.4657 33.1657 75.8866 29.6813 72.4022C26.1969 68.9179 23.6178 64.634 22.1689 59.9242C20.72 55.2144 20.4452 50.2216 21.3686 45.3812C22.2919 40.5409 24.3853 35.9999 27.4663 32.1542C30.5473 28.3085 34.5223 25.2749 39.0446 23.3179",
    stroke: "#FFB000",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7498 51.0417C81.026 51.0417 81.2503 50.8178 81.2457 50.5417C81.1829 46.7449 80.4047 42.9925 78.9504 39.4815C77.4323 35.8164 75.2071 32.4863 72.402 29.6812C69.5969 26.8761 66.2668 24.651 62.6017 23.1328C59.0907 21.6785 55.3383 20.9004 51.5415 20.8375C51.2654 20.8329 51.0415 21.0572 51.0415 21.3334L51.0415 50.0417C51.0415 50.594 51.4892 51.0417 52.0415 51.0417H80.7498Z",
    stroke: "#FFB000",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/pie-chart.bcdfe9fb70652db655898ad42a23957f.svg";
export { ForwardRef as ReactComponent };